import { GovIcon, GovMessage } from '@gov-design-system-ce/react';
import type { MySubmissionVoterCardAplication } from '@gov-nx/api';
import { MarkdownRender } from '@gov-nx/component/web';
import { useLocale } from '@gov-nx/core/service';
import { PageCode, useVoterCardApplicationMessages } from '@gov-nx/module/page';
import {
	Attachment,
	DocumentDownloadContainer,
	LayoutGap,
} from '@gov-nx/ui/web';

interface VoterRegistrationMessageProps {
	submission: MySubmissionVoterCardAplication;
	onDownload: (onSuccess: () => void) => void;
}

export const VoterRegistrationMessage = ({
	submission,
	onDownload,
}: VoterRegistrationMessageProps) => {
	const { t } = useLocale(PageCode['moje-podani']);

	const { specificToType, specificToPickupOption } =
		useVoterCardApplicationMessages(submission);

	return (
		<LayoutGap>
			<GovMessage
				color="primary"
				type="subtle"
				icon={
					<GovIcon
						type="components"
						name="lightbulb-fill"
					/>
				}>
				{specificToType.map((message) => (
					<MarkdownRender key={message}>{message}</MarkdownRender>
				))}
			</GovMessage>

			<GovMessage
				color="primary"
				type="subtle"
				icon={
					<GovIcon
						type="components"
						name="lightbulb-fill"
					/>
				}>
				<MarkdownRender>{t('volicsky-prukaz.pouceni')}</MarkdownRender>

				{specificToPickupOption.map((message) => (
					<MarkdownRender key={message}>{message}</MarkdownRender>
				))}

				<MarkdownRender>
					{t('volicsky-prukaz.pouceni-v-pripade-dotazu')}
				</MarkdownRender>
			</GovMessage>
			{submission.parametry.zpusobPrevzeti === 'URAD' ? (
				<div>
					<br />
					<DocumentDownloadContainer>
						<Attachment
							downloadLabel={t('volicsky-prukaz.stahnout.stitek')}
							name={t('volicsky-prukaz.stahnout.nazev-souboru')}
							onDownload={onDownload}
							size={17.062 * 1024}
						/>
					</DocumentDownloadContainer>
				</div>
			) : null}
		</LayoutGap>
	);
};
